
import { ModelBase } from "@models/UpsertableBase";
import { 
  SpellSlotTableEntry 
} from "@dndModels/misc";
import { DataType } from "@dndModels/Types";

/**
 * This is how I make the table of spell slots for
 * the various magical classes/subclasses.
 * 
 */

export class SpellSlotType extends ModelBase {
  data_type: DataType = "spell_slot_type";
  refresh_rule: "Short Rest" | "Long Rest";
  slot_name: string;
  entries: SpellSlotTableEntry[];
  
  constructor(obj?: any) {
    super(obj);
    this.refresh_rule = obj ? obj.refresh_rule : "Long Rest";
    this.slot_name = obj && obj.slot_name ? obj.slot_name : "Slots";
    this.entries = [];
    if (obj && obj.entries) {
      for (const entry of obj.entries) {
        this.entries.push(new SpellSlotTableEntry(entry));
      }
    }
    this.loaded = true;
  }

  entryForLevel(caster_level: number) {
    const highest_level = Math.max(0,...this.entries.filter(o => o.level <= caster_level).map(o => o.level));
    return this.entries.find(o => o.level === highest_level);
  }

  toDBObj(): any {
    const entries: any[] = [];
    this.entries.forEach(entry => {
      entries.push(entry.toDBObj());
    });
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      refresh_rule: this.refresh_rule,
      slot_name: this.slot_name,
      entries
    };
  }

  toLight(): any {
    return this.toDBObj();
  }

  copy(copyMe: SpellSlotType, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.refresh_rule = copyMe.refresh_rule;
    this.slot_name = copyMe.slot_name;
    this.entries = [];
    copyMe.entries.forEach(entry => {
      this.entries.push(entry.clone());
    });
  }

  clone(drop_ids = false): SpellSlotType {
    const new_obj = new SpellSlotType();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}